var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.5 12",
    style: {
      enableBackground: "new 0 0 12.5 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F02B2B;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.761 -467.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-906.77 104.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1021.3,374.1l-2.3-2.5c-0.4-0.4-0.6-0.9-0.5-1.4v-2.8c0-0.5,0.1-1,0.5-1.4l2.3-2.5c0.4-0.5,1-0.7,1.6-0.7 h3.8c0.6,0,1.2,0.2,1.6,0.7l2.3,2.5c0.4,0.4,0.6,0.9,0.5,1.4v2.8c0,0.5-0.1,1-0.5,1.4l-2.3,2.5c-0.4,0.5-1,0.7-1.6,0.7h-3.8 C1022.3,374.8,1021.7,374.5,1021.3,374.1z M1025.5,371.3c0-0.4-0.3-0.7-0.7-0.7c0,0,0,0,0,0c-0.4,0-0.7,0.3-0.6,0.7 c0,0.4,0.3,0.7,0.7,0.6C1025.2,371.9,1025.5,371.6,1025.5,371.3z M1025.3,369.2l0.1-3.1c0-0.3-0.2-0.6-0.6-0.6c0,0,0,0,0,0 c-0.3,0-0.6,0.2-0.6,0.5c0,0,0,0,0,0.1l0.1,3.1c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0C1025,369.7,1025.3,369.5,1025.3,369.2 C1025.3,369.2,1025.3,369.2,1025.3,369.2L1025.3,369.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-906.77 104.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1024.8,369.7c0.3,0,0.5-0.2,0.5-0.4c0,0,0-0.1,0-0.1l0.1-3.1c0-0.3-0.2-0.6-0.6-0.6c0,0,0,0,0,0 c-0.3,0-0.6,0.2-0.6,0.5c0,0,0,0,0,0.1l0.1,3.1C1024.2,369.5,1024.4,369.7,1024.8,369.7C1024.7,369.7,1024.8,369.7,1024.8,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1024.8,372.1c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7 C1024.1,371.8,1024.4,372.1,1024.8,372.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.24ce6c8e55803ce2b7027472dff95324.svg";
export { ForwardRef as ReactComponent };